"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ReduxFormMaterialUISelect;

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _react = _interopRequireDefault(require("react"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("./utils");

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      flexDirection: "column"
    },
    label: {
      position: "relative",
      paddingRight: theme.spacing()
    },
    base: {
      flexGrow: 1
    },
    innerRoot: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      display: 'flex'
    }
  };
});

function ReduxFormMaterialUISelect(_ref) {
  var _ref$input = _ref.input,
      name = _ref$input.name,
      input = _objectWithoutProperties(_ref$input, ["name"]),
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      warning = _ref$meta.warning,
      meta = _objectWithoutProperties(_ref$meta, ["touched", "error", "warning"]),
      defaultValue = _ref.defaultValue,
      helperText = _ref.helperText,
      children = _ref.children,
      className = _ref.className,
      labelPlacement = _ref.labelPlacement,
      props = _objectWithoutProperties(_ref, ["input", "meta", "defaultValue", "helperText", "children", "className", "labelPlacement"]);
  /*
      On form control:
      flex-direction: row
      align-items: flex-start;
       On label:
      position: relative;
      padding-right: theme-spacing
       On InputBase:
      flex-grow: 1
  */


  var classes = useStyles();
  return _react["default"].createElement(_FormControl["default"], {
    error: touched && !!error,
    className: (0, _classnames["default"])(className, labelPlacement === "left" ? classes.root : ""),
    fullWidth: props.fullWidth
  }, _react["default"].createElement("div", {
    className: labelPlacement === "left" ? classes.innerRoot : ""
  }, _react["default"].createElement(_InputLabel["default"], {
    htmlFor: name,
    className: labelPlacement === "left" ? classes.label : "",
    shrink: labelPlacement === "left" ? false : !!input.value || meta.active
  }, props.label), _react["default"].createElement(_Select["default"], _extends({}, input, props, {
    className: labelPlacement === "left" ? classes.base : ""
  }), children)), (0, _utils.getHelperText)(touched, error, warning, helperText));
}